// src/components/PersonalLoan.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PersonalLoan.css';

const PersonalLoan = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/home');
  };

  const loanFeatures = [
    { icon: '💰', title: 'Loan Amount', value: 'Up to ₹40 Lakh' },
    { icon: '📅', title: 'Loan Tenure', value: 'Up to 84 months (7 years)' },
    { icon: '🛡️', title: 'Loan Type', value: 'Unsecured (No Collateral)' },
    { icon: '⚡', title: 'Disbursement', value: 'Instant approval possible' },
    { icon: '🏦', title: 'Interest Rate', value: 'Competitive rates' },
    { icon: '📝', title: 'No Hidden Charges', value: 'Transparent pricing' }
  ];

  const eligibilityCriteria = [
    { requirement: 'Age Range', details: '21 to 60 years' },
    { requirement: 'Minimum Income', details: '₹15,000 net monthly (salaried)' },
    { requirement: 'Credit Score', details: '650 or above' },
    { requirement: 'Residency', details: 'Resident Citizen of India' },
    { requirement: 'Debt-to-Income Ratio', details: 'Lender-specific assessment' },
    { requirement: 'Employment Stability', details: 'Steady employment history' }
  ];

  const requiredDocuments = [
    {
      category: 'Identity & Address Proof',
      items: ['PAN Card', 'Aadhaar Card', 'Passport', 'Voter\'s ID', 'Driving License']
    },
    {
      category: 'Income Proof',
      items: ['1 year Bank statements', '3 months Salary slips']
    },
    {
      category: 'Employment Proof',
      items: ['Employment certificate', 'Office address proof']
    },
    {
      category: 'For Self-Employed',
      items: ['GST/VAT Registration', 'Business proof documents', '2-3 years ITR']
    }
  ];

  const feesAndCharges = [
    { type: 'Processing Fee', charge: '₹2,999 to 5% of loan amount' },
    { type: 'Pre-closure/Cancellation', charge: '₹3,000 to 5% of loan amount' },
    { type: 'Penal Charges (Late Payment)', charge: 'Approx. 2% per month' },
    { type: 'Stamp Duty', charge: '₹150 to ₹300' },
    { type: 'Cheque/EMI Bounce', charge: '₹499 to ₹599' },
    { type: 'Legal Fees', charge: 'As per actuals' }
  ];

  return (
    <div className="personal-container">
      {/* <button className="personal-back-btn" onClick={handleGoBack}>
        <span className="personal-back-arrow">←</span>
        <span className="personal-back-text">Back to Home</span>
        <div className="personal-back-hover-effect"></div>
      </button> */}

      <div className="personal-content">
        {/* Hero Section */}
        <div className="personal-hero-section">
          <div className="personal-hero-icon-container">
            <span className="personal-hero-icon">💳</span>
          </div>
          <h1 className="personal-main-title">Personal Loan</h1>
          <p className="personal-hero-subtitle">Get instant personal loans up to ₹40 Lakh with flexible repayment options</p>
          <div className="personal-cta-buttons">
            <button className="personal-apply-now-btn">
              Apply Now
              <span className="personal-arrow">→</span>
            </button>
            <button className="personal-check-eligibility-btn">
              Check Eligibility
            </button>
          </div>
        </div>

        {/* Key Features Section */}
        <div className="personal-section-card">
          <div className="personal-section-header">
            <h2 className="personal-section-title">📝 Key Loan Features</h2>
            <div className="personal-section-divider"></div>
          </div>
          
          <div className="personal-features-grid">
            {loanFeatures.map((feature, index) => (
              <div className="personal-feature-card" key={index}>
                <div className="personal-feature-icon-card">{feature.icon}</div>
                <h3 className="personal-feature-title">{feature.title}</h3>
                <p className="personal-feature-description">{feature.value}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Eligibility & Documents Section */}
        <div className="personal-section-card">
          <div className="personal-section-header">
            <h2 className="personal-section-title">✅ Eligibility and Required Documents</h2>
            <div className="personal-section-divider"></div>
          </div>

          <div className="personal-two-column-layout">
            {/* Eligibility Criteria */}
            <div className="personal-eligibility-section">
              <h3 className="personal-subsection-title">Eligibility Criteria</h3>
              <div className="personal-criteria-list">
                {eligibilityCriteria.map((criteria, index) => (
                  <div className="personal-criteria-item" key={index}>
                    <div className="personal-check-icon">✓</div>
                    <div className="personal-criteria-content">
                      <span className="personal-criteria-requirement">{criteria.requirement}:</span>
                      <span className="personal-criteria-details">{criteria.details}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Required Documents */}
            <div className="personal-documents-section">
              <h3 className="personal-subsection-title">Required Documents</h3>
              <div className="personal-documents-list">
                {requiredDocuments.map((docCategory, index) => (
                  <div className="personal-document-category" key={index}>
                    <h4 className="personal-category-title">{docCategory.category}</h4>
                    <ul className="personal-document-items">
                      {docCategory.items.map((item, itemIndex) => (
                        <li key={itemIndex} className="personal-document-item">
                          <span className="personal-bullet">•</span>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Fees & Charges Section */}
        <div className="personal-section-card">
          <div className="personal-section-header">
            <h2 className="personal-section-title personal-warning">⚠️ Important Fees to Consider</h2>
            <div className="personal-section-divider personal-warning"></div>
          </div>

          <div className="personal-fees-table-container">
            <table className="personal-fees-table">
              <thead>
                <tr>
                  <th>Type of Charge</th>
                  <th>Amount / Percentage</th>
                </tr>
              </thead>
              <tbody>
                {feesAndCharges.map((fee, index) => (
                  <tr key={index}>
                    <td className="personal-fee-type">{fee.type}</td>
                    <td className="personal-fee-amount">{fee.charge}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="personal-important-note">
            <div className="personal-note-icon">ℹ️</div>
            <div className="personal-note-content">
              <strong>Important:</strong> All fees may vary between lenders. Please review the final loan agreement carefully before signing.
            </div>
          </div>
        </div>

        {/* EMI Calculator Section */}
        <div className="personal-section-card">
          <div className="personal-section-header">
            <h2 className="personal-section-title">📊 EMI Calculator</h2>
            <div className="personal-section-divider"></div>
          </div>

          <div className="personal-emi-calculator">
            <div className="personal-calculator-inputs">
              <div className="personal-input-group">
                <label>Loan Amount (₹)</label>
                <input 
                  type="range" 
                  min="10000" 
                  max="4000000" 
                  step="10000" 
                  defaultValue="1000000"
                  className="personal-slider"
                />
                <div className="personal-value-display">₹10,00,000</div>
              </div>

              <div className="personal-input-group">
                <label>Loan Tenure (Months)</label>
                <input 
                  type="range" 
                  min="12" 
                  max="84" 
                  step="6" 
                  defaultValue="48"
                  className="personal-slider"
                />
                <div className="personal-value-display">48 months</div>
              </div>

              <div className="personal-input-group">
                <label>Interest Rate (% p.a.)</label>
                <input 
                  type="range" 
                  min="10" 
                  max="24" 
                  step="0.5" 
                  defaultValue="14"
                  className="personal-slider"
                />
                <div className="personal-value-display">14%</div>
              </div>
            </div>

            <div className="personal-emi-result">
              <div className="personal-emi-breakdown">
                <div className="personal-emi-item">
                  <span className="personal-emi-label">Monthly EMI</span>
                  <span className="personal-emi-value">₹27,357</span>
                </div>
                <div className="personal-emi-item">
                  <span className="personal-emi-label">Total Interest</span>
                  <span className="personal-emi-value">₹3,13,136</span>
                </div>
                <div className="personal-emi-item">
                  <span className="personal-emi-label">Total Payment</span>
                  <span className="personal-emi-value">₹13,13,136</span>
                </div>
              </div>
              <button className="personal-calculate-emi-btn">
                Calculate EMI
              </button>
            </div>
          </div>
        </div>

        {/* Contact & Apply Section */}
        <div className="personal-contact-apply-section">
          <div className="personal-contact-info">
            <h3>Need Assistance?</h3>
            <a href="tel:18001234567" className="personal-contact-phone">
              📞 9909002220
            </a>
            <p className="personal-timing">Mon-Sat: 9AM-9PM | Sun: 10AM-6PM</p>
          </div>
          
          <div className="personal-final-cta">
            <p className="personal-cta-text">Ready to apply for your personal loan?</p>
            <button className="personal-final-apply-btn">
              Apply Now - Get Instant Approval
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalLoan;